<template>
  <div class="kk-file-preview">
    <div class="preview-toolbar" v-if="showToolbar && $slots.toolbar">
      <slot name="toolbar"></slot>
    </div>
    <div class="preview-toolbar" v-else-if="showToolbar && !$slots.toolbar">
      <el-button icon="el-icon-full-screen" @click="handleFullScreen" size="mini" type="primary">全屏预览</el-button>
    </div>
    <div ref="previewContainer" class="preview-container">
      <iframe
        :src="previewUrl"
        frameborder="0"
        width="100%"
        height="400px"
        allowfullscreen
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation"
        referrerpolicy="no-referrer"
        loading="lazy"
        @load="onIframeLoad"
        @error="onIframeError"
      ></iframe>
    </div>
  </div>
</template>

<script>
import settings from '@/settings'

function base64Encode(str) {
  // 兼容中文
  return btoa(unescape(encodeURIComponent(str)))
}

export default {
  name: 'KkFilePreview',
  props: {
    url: {
      type: String,
      required: true
    },
    showToolbar: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    previewUrl() {
      if (!this.url) return ''
      const encoded = encodeURIComponent(base64Encode(this.url))
      const finalUrl = `${settings.kkPreviewPath}/onlinePreview?url=${encoded}`
      console.log('KkFilePreview URL:', {
        original: this.url,
        base64: base64Encode(this.url),
        encoded: encoded,
        final: finalUrl
      })
      return finalUrl
    }
  },
  methods: {
    handleFullScreen() {
      const el = this.$refs.previewContainer
      if (el.requestFullscreen) {
        el.requestFullscreen()
      } else if (el.mozRequestFullScreen) {
        el.mozRequestFullScreen()
      } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen()
      } else if (el.msRequestFullscreen) {
        el.msRequestFullscreen()
      }
    },
    onIframeLoad(event) {
      console.log('Iframe loaded successfully:', event)
      try {
        const iframe = event.target
        console.log('Iframe contentWindow:', iframe.contentWindow)
        console.log('Iframe src:', iframe.src)
      } catch (error) {
        console.log('Cannot access iframe content due to cross-origin:', error)
      }
    },
    onIframeError(event) {
      console.error('Iframe failed to load:', event)
    }
  }
}
</script>

<style scoped>
.kk-file-preview {
  width: 100%;
  margin: 0;
  padding: 0;
}
.preview-toolbar {
  text-align: right;
  margin-bottom: 8px;
}
.preview-container {
  width: 100%;
  height: 400px;
  background: #f5f7fa;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  border: 1px solid #e4e7ed;
  margin: 0;
  padding: 0;
}
.preview-container iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style> 